import "./App.css";
import { Route } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Dashboard from "./views/Dashboard";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    document.title = "Traffic Department Admin Panel";
  }, []);
  return (
    <div className="App">
      <Route path="/admin" component={Dashboard}></Route>
    </div>
  );
}

export default App;
